// Hub labels for the driver's audio choice that the phone reports in its status frame.
// The driver can only turn audio off; "off" wins over the capture-settings audio switch.
export const AUDIO_CHOICE_BADGE: Record<'off' | 'organizer', { label: string; className: string; title: string }> = {
  off: {
    label: 'audio off (driver)',
    className: 'border-status-warning text-status-warning',
    title: 'The driver turned audio recording off in the app; recordings from this phone have no audio',
  },
  organizer: {
    label: 'audio: organizer setting',
    className: 'border-fg-muted text-fg-muted',
    title: 'The driver has not turned audio off; the phone follows the organizer audio setting',
  },
};
